class ProceduralMesh extends THREE.Mesh {
    constructor(geometry, material) {
        super(geometry, material);

        this.type = "ProceduralMesh";
        this.isProceduralMesh = true;
    }
}

export default ProceduralMesh;
export { ProceduralMesh };